<template>
  <!-- 硬件管理中心头部 -->
  <div class="gat-head">
    <div class="head-left">
      <h1 class="head-title">
        <router-link :to="{ name: 'home' }">
          <img :src="Logo.img" alt="AI-training" class="head-title-img" />
          <!-- <i class="i-spot"></i> -->
          <!-- <span class="title-name">硬件管理中心</span> -->
        </router-link>
        <i class="i-spot"></i>
        <router-link :to="{ name: 'hardware-center' }">
          <span class="title-name">硬件管理中心</span>
        </router-link>
      </h1>
    </div>

    <!-- <div class="head-center">
      <div class="items">
        <span
          v-for="(item, idx) in Nav"
          :key="item.id || idx"
          @click="onNewWindow(item, idx)"
          :class="{ dispermit: item.redirect === 'unDo' }"
        >
          <router-link
            v-if="item.label !== '体验实训' || experianceAI"
            :class="['nav-item', originPath === idx ? 'active' : '']"
            :to="{ name: item.redirect }"
            >{{ item.label }}
          </router-link>
        </span>
      </div>
    </div> -->

    <div class="head-right">
      <div class="search">
        <!-- <input type="text" style="display:none" /> -->
        <!-- <input
          class="search-input"
          autocomplete="off"
          type="text"
          placeholder="搜索"
          readonly
          v-model="searchVal"
          @mousedown="focusInput($event)"
          @blur="getInput($event)"
          @keyup.enter="getInput($event)"
        /> -->
        <div class="ipt">
          <el-input
            placeholder="搜索"
            v-model.trim="searchVal"
            @keyup.enter.native="getInput($event)"
          >
            <i slot="suffix" class="icon-search-box" @click="getInput($event)">
              <span class="el-icon-search"></span>
            </i>
          </el-input>
        </div>
      </div>
      <!-- <span class="sep"></span> -->
      <div class="userinfo">
        <div class="profile">
          <img
            @click="toLogin"
            :src="
              accountInfo && accountInfo.photo && hasLogin
                ? (/^(https?:\/\/)/.test(accountInfo.photo) ? accountInfo.photo : photoBaseUrl + accountInfo.photo)
                : User.profile2
            "
            alt
          />
          <div class="profile-menu" v-show="hasLogin">
            <ul>
              <li @click="JumpPersonal">个人空间</li>
              <!-- <li v-if="false">课程管理</li> -->
              <li @click="JumpSetting">账号设置</li>
              <li @click="quitLogin">退出登录</li>
            </ul>
          </div>
        </div>
        <div class="user-info-wrap">
          <span v-if="accountInfo.realName" class="real-name">{{
            accountInfo.realName
          }}</span>
          <span v-if="userRole" class="role-name">{{
            accountInfo.roleNames || accountInfo.roleName
          }}</span>
        </div>
        <slot name="right-button">
          <!-- <button
            type="button"
            class="el-button el-button--primary el-button--medium ml20"
            @click="activeCreatePopup"
            v-if="hasLogin && creationShow && userRole !== 2"
          >
            <span>马上创作</span>
          </button> -->
          <button
            type="button"
            class="el-button el-button--primary el-button--medium ml20"
            @click.stop="activeLoginPopup"
            v-if="!hasLogin"
          >
            <span>登录</span>
            <!-- <span>登录/注册</span> -->
          </button>
        </slot>
      </div>
    </div>

    <div class="popup-list" v-show="popupActive == 'login'">
      <!-- 登录/注册 -->
      <div
        id="popup"
        class="popup popup-login-wrap"
        @mousedown="backgroundClickedCancel"
      >
        <div class="popup-inner">
          <div class="popup-head">
            <i class="icon-close" title="关闭" @click.stop="cancelPopup">
              <icon-base
                :icon-name="Icons.PopupClose.iconName"
                v-bind="Icons.PopupClose"
              >
                <icon-popup-close
                  class="path-icon-close"
                  :icon-name="Icons.PopupClose.iconName"
                  v-bind="Icons.PopupClose"
                />
              </icon-base>
            </i>
          </div>
          <!-- 登录注册找回密码弹框 -->
          <div class="popup-content">
            <div class="popup-login">
              <div class="tab">
                <span class="item active" v-show="isLogin">用户 登录</span>
                <span
                  :class="['item', isPhone == true ? 'active' : '']"
                  v-show="!isLogin && !isSafe && !isReset"
                  @click="RegPhone"
                  >手机注册</span
                >
                <span
                  :class="['item', isPhone == false ? 'active' : '']"
                  v-show="!isLogin && !isSafe && !isReset"
                  @click="RegMail"
                  >邮箱注册</span
                >
                <span
                  class="item active"
                  v-show="!isLogin && isSafe && !isReset"
                  >账号安全</span
                >
                <span
                  class="item active"
                  v-show="!isLogin && !isSafe && isReset"
                  >重置密码</span
                >
              </div>
              <!--登录-->
              <el-form
                class="login"
                :model="loginForm"
                ref="loginForm"
                :rules="loginRules"
                v-if="isLogin"
                status-icon
                @submit.native.prevent
              >
                <el-form-item class="input-item" prop="account">
                  <i class="ico01"></i>
                  <el-input
                    type="text"
                    class="Acount"
                    autofocus="autofocus"
                    placeholder="手机号/邮箱"
                    v-model.trim="loginForm.loginName"
                    autocomplete="off"
                  />
                  <!-- <div class="tip"></div> -->
                </el-form-item>
                <el-form-item class="input-item mb60" prop="pass">
                  <i class="ico02"></i>
                  <el-input
                    type="password"
                    class="password"
                    placeholder="密码"
                    v-model.trim="loginForm.Password"
                    @keyup.enter.native="Login('loginForm')"
                  />
                </el-form-item>
                <div>
                  <el-button class="input-login" @click="Login('loginForm')"
                    >登录</el-button
                  >
                  <input
                    v-if="false"
                    class="input-login-reg"
                    value="注册"
                    readonly="readonly"
                    @click="RegSwitch"
                    native-type="submit"
                  />
                </div>
                <div class="note">
                  <el-checkbox
                    v-model="LoginTeenDays"
                    v-if="false"
                  ></el-checkbox>
                  <span class="info" v-if="false">十天内免登录</span>
                  <span class="forget" @click="SafeSwich" v-if="false"
                    >忘记密码</span
                  >
                </div>
              </el-form>
              <!--手机注册-->
              <el-form
                class="phone"
                v-show="!isLogin && isPhone && !isSafe && !isReset"
                :model="signupForm"
                ref="signupForm"
                :rules="signupRules"
                status-icon
                @submit.native.prevent
              >
                <el-form-item class="input-item" prop="phone2">
                  <i class="ico03"></i>
                  <el-input
                    type="text"
                    class="input number-phone"
                    autofocus="autofocus"
                    autocomplete="off"
                    placeholder="输入手机号码"
                    v-model.trim="signupForm.loginName"
                  />
                  <em class="ico05"></em>
                </el-form-item>
                <el-form-item class="input-item" prop="pass2">
                  <i class="ico02"></i>
                  <el-input
                    type="password"
                    class="input password-phone"
                    placeholder="设置密码（6-20位字母、数字）"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="signupForm.Password"
                  />
                </el-form-item>

                <el-form-item class="input-item" prop="code">
                  <el-input
                    type="password"
                    class="input input-code"
                    placeholder="输入手机验证码"
                    v-model.trim="signupForm.code"
                  />
                  <span class="send-code" @click="sendVerifyCode('phone', '1')"
                    >{{ codeVal != 'sending' ? '发送验证码' : codeTimer
                    }}<em v-if="codeVal == 'sending'">s</em></span
                  >
                </el-form-item>

                <div class="note">
                  <el-checkbox v-model="phoneChecked"></el-checkbox>
                  <span class="info">
                    我已阅读并同意
                    <em class="serve">《服务条款》</em>和
                    <em class="privacy">《隐私协议》</em>
                  </span>
                </div>

                <div>
                  <input
                    :class="['input-reg', !phoneChecked ? 'disabled' : '']"
                    value="注册"
                    readonly="readonly"
                    @click="confirmPhoneSignup('signupForm')"
                  />
                </div>
              </el-form>
              <!--邮箱注册-->
              <el-form
                class="mail"
                v-show="!isLogin && !isPhone && !isSafe && !isReset"
                :model="signupEmailForm"
                ref="signupEmailForm"
                :rules="signupEmailRules"
                status-icon
                @submit.native.prevent
              >
                <el-form-item class="input-item" prop="email">
                  <i class="ico04"></i>
                  <el-input
                    type="text"
                    class="input number-phone"
                    placeholder="输入邮箱地址"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="signupEmailForm.loginName"
                  />
                  <div class="tip"></div>
                  <em class="ico06"></em>
                </el-form-item>
                <el-form-item class="input-item" prop="pass3">
                  <i class="ico02"></i>
                  <el-input
                    type="password"
                    class="input password-phone"
                    placeholder="设置密码（6-20位字母、数字）"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="signupEmailForm.Password"
                  />
                </el-form-item>

                <el-form-item class="input-item" prop="emaiCode">
                  <el-input
                    type="password"
                    class="input input-code"
                    placeholder="输入邮箱验证码"
                    v-model.trim="signupEmailForm.code"
                  />
                  <span class="send-code" @click="sendVerifyCode('email', '1')"
                    >{{ codeVal != 'sending' ? '发送验证码' : codeTimer
                    }}<em v-if="codeVal == 'sending'">s</em></span
                  >
                </el-form-item>

                <div class="note">
                  <el-checkbox v-model="emailChecked"></el-checkbox>
                  <span class="info">
                    我已阅读并同意
                    <em class="serve">《服务条款》</em>和
                    <em class="privacy">《隐私协议》</em>
                  </span>
                </div>

                <div>
                  <input
                    class="input-reg"
                    value="注册"
                    readonly="readonly"
                    :class="['input-reg', !emailChecked ? 'disabled' : '']"
                    @click="confirmEmileSignup('signupEmailForm')"
                  />
                </div>
              </el-form>
              <!--账号安全-->
              <el-form
                class="safe"
                v-show="!isLogin && isSafe && !isReset"
                :model="safeForm"
                ref="safeForm"
                :rules="safeRules"
                status-icon
                @submit.native.prevent
              >
                <div class="input-item mb0">
                  <p class="reminder">请输入您的账号信息</p>
                </div>

                <el-form-item class="input-item mb40" prop="safeAccount">
                  <i class="ico03"></i>
                  <el-input
                    class="input input-code w100"
                    placeholder="请输入手机号码/邮箱"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="safeForm.loginName"
                  />
                </el-form-item>

                <el-form-item class="input-item" prop="safeCode">
                  <el-input
                    class="input input-code"
                    placeholder="输入验证码"
                    v-model.trim="safeForm.code"
                  />
                  <span
                    v-if="isSafe"
                    :class="[
                      'send-code',
                      !safeForm.loginName ? 'disabled' : '',
                    ]"
                    @click="sendVerifyCode('', '2')"
                    >{{ codeVal != 'sending' ? '发送验证码' : codeTimer
                    }}<em v-if="codeVal == 'sending'">s</em></span
                  >
                </el-form-item>

                <div>
                  <input
                    :class="[
                      'input-reg',
                      'mt50',
                      !saveNextVal || codeVal == 'sended' ? 'disabled' : '',
                    ]"
                    readonly="readonly"
                    value="下一步"
                    @click="SafeNext('safeForm')"
                  />
                </div>
              </el-form>
              <!--重置密码-->
              <el-form
                class="safe reset-form"
                v-show="!isLogin && !isSafe && isReset"
                :model="resetForm"
                ref="resetForm"
                :rules="resetRules"
                status-icon
                @submit.native.prevent
              >
                <el-form-item class="input-item" prop="newPass">
                  <el-input
                    type="password"
                    class="input input-code w100"
                    placeholder="8-16位密码，区分大小写"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="resetForm.Password"
                    @input="varifyPassSet"
                  />
                </el-form-item>

                <!-- <el-form-item class="input-item" prop="confirmPass">
                  <el-input
                    type="password"
                    class="input input-code w100"
                    placeholder="再次确认密码"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="resetForm.Password2"
                  />
                </el-form-item> -->
                <div class="pass-show-wrap">
                  <span :class="[passStatus ? 'weak' : '']"></span>
                  <span
                    :class="[
                      passStatus == 'medium' || passStatus == 'strong'
                        ? 'medium'
                        : '',
                    ]"
                  ></span>
                  <span
                    :class="[passStatus == 'strong' ? 'strong' : '']"
                  ></span>
                  <p>密码强度</p>
                </div>
                <div v-show="resetError" class="tip-wrap">
                  <p>*长度为8-16个字符</p>
                  <p>*不能使用空格、中文</p>
                  <p>*不能含有非法字符</p>
                </div>
                <div>
                  <input
                    class="input-reg mt50 confirm-reset"
                    value="重置"
                    readonly="readonly"
                    @click="Reset('resetForm')"
                  />
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSearch from '@/components/icons/typography/Search'
import IconPopupClose from '@/components/icons/typography/PopupClose'
import LOGIN from '@/axios/login/login'
import bus from '@/utils/bus'
import utils from '@/utils/index'
export default {
  name: 'gat-head',
  props: {
    openLogin: {
      type: String,
      default: null,
    },
    creationShow: {
      type: Boolean,
      default: true,
    },
  },
  components: { IconPopupClose },
  data() {
    const pas_match = /^(?=.*[a-zA-Z])((?=.*[0-9])|(?=.*[._~!@#$^&*]))[A-Za-z0-9._~!@#$^&*]{8,16}$/, //验证密码
      match_pass = /^[\da-zA-Z._~!@#$^&*]{6,16}$/, //验证密码
      phone_match = /^1[358]\d{9}$/, //验证电话
      mail_match = /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/

    var validateAccount = (rule, value, callback) => {
      if (this.loginForm.loginName == '') {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
    }

    var validatePass = (rule, value, callback) => {
      if (this.loginForm.Password == '') {
        callback(new Error('请输入密码'))
      } else {
        if (!match_pass.test(this.loginForm.Password)) {
          callback(new Error('请输入6-16位密码'))
        }
        this.$refs.loginForm.validateField('checkPass')
        callback()
      }
    }

    //验证手机注册
    var validatePhone = (rule, value, callback) => {
      if (!this.signupForm.loginName || this.signupForm.loginName == '') {
        callback(new Error('请输入手机号'))
      } else if (!phone_match.test(this.signupForm.loginName)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }

    var validatePass2 = (rule, value, callback) => {
      if (this.signupForm.Password == '') {
        callback(new Error('请输入密码'))
      } else {
        if (!match_pass.test(this.signupForm.Password)) {
          callback(new Error('请输入8-16位密码'))
        }
        this.$refs.signupForm.validateField('checkPass')
        callback()
      }
    }
    var validateCode = (rule, value, callback) => {
      if (this.signupForm.code == '') {
        callback(new Error('请输入验证码'))
      } else if (this.codeTimer == 0 && this.codeVal == 'sended') {
        callback(new Error('验证码失效，请重新发送'))
      } else if (this.code != this.signupForm.code) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }

    //验证邮箱注册
    var validateEmail = (rule, value, callback) => {
      if (
        !this.signupEmailForm.loginName ||
        this.signupEmailForm.loginName == ''
      ) {
        callback(new Error('请输入正确的邮箱'))
      } else if (!mail_match.test(this.signupEmailForm.loginName)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
      }
    }
    var validatePass3 = (rule, value, callback) => {
      if (this.signupEmailForm.Password == '') {
        callback(new Error('请输入密码'))
      } else {
        if (!match_pass.test(this.signupEmailForm.Password)) {
          callback(new Error('请输入8-16位密码'))
        }
        this.$refs.signupEmailForm.validateField('checkPass')
        callback()
      }
    }
    var validateEmaiCode = (rule, value, callback) => {
      if (this.signupEmailForm.code == '') {
        callback(new Error('请输入验证码'))
      } else if (this.codeTimer == 0 && this.codeVal == 'sended') {
        callback(new Error('验证码失效，请重新发送'))
      } else if (this.code != this.signupEmailForm.code) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    //安全验证，验证手机和邮箱
    var validateSafe = (rule, value, callback) => {
      let account = this.safeForm.loginName
      if (!this.safeForm.loginName || this.safeForm.loginName == '') {
        callback(new Error('请输入正确的账户'))
      } else if (!phone_match.test(account) && !mail_match.test(account)) {
        callback(new Error('账户格式不正确'))
      } else {
        callback()
      }
    }
    var validateSafeCode = (rule, value, callback) => {
      if (this.safeForm.code == '') {
        callback(new Error('请输入验证码'))
        this.saveNextVal = false
      } else if (this.codeTimer == 0 && this.codeVal == 'sended') {
        callback(new Error('验证码失效，请重新发送'))
        this.saveNextVal = false
      } else if (this.code != this.safeForm.code) {
        callback(new Error('验证码错误'))
        this.saveNextVal = false
      } else {
        callback()
        this.saveNextVal = true
      }
    }

    //重置密码
    var validateNewPass = (rule, value, callback) => {
      let pass = this.resetForm.Password
      if (this.resetForm.Password == '') {
        callback(new Error(''))
        this.resetError = true
      } else {
        if (!match_pass.test(this.resetForm.Password)) {
          callback(new Error(''))
          this.resetError = true
          // callback(new Error("请输入8-16位密码"));
        }
        if (/[\s|\u4e00-\u9fa5].*/.test(pass)) {
          this.resetError = true
          callback(new Error(''))
          // callback(new Error("不能使用空格、中文"));
        } else if (pass.length < 8 || pass.length > 16) {
          callback(new Error(''))
          // callback(new Error("长度为8-16个字符"));
          this.resetError = true
        } else if (/[\s|\u4e00-\u9fa5].*/.test(pass)) {
          callback(new Error('不能使用空格、中文'))
          this.resetError = true
          // callback(new Error("不能使用空格、中文"));
        } else if (!this.passStatus) {
          callback(new Error(''))
          // callback(new Error("不能含有非法字符"));
          this.resetError = true
        } else {
          this.$refs.resetForm.validateField('checkPass')
          this.resetError = false
          callback()
        }
      }
    }

    return {
      token: null,
      searchCoursePage: false,
      originPath: null,
      experianceAI: window.gtaAiConfig.EXPERIENCE_AI,
      loginRules: {
        //登录验证
        account: [{ validator: validateAccount, trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
      },
      //手机注册验证
      signupRules: {
        phone2: [{ validator: validatePhone, trigger: 'blur', equired: true }],
        pass2: [{ validator: validatePass2, trigger: 'blur', equired: true }],
        code: [{ validator: validateCode, trigger: 'blur', equired: true }],
      },
      //邮箱注册验证
      signupEmailRules: {
        email: [{ validator: validateEmail, trigger: 'blur', equired: true }],
        pass3: [{ validator: validatePass3, trigger: 'blur', equired: true }],
        emaiCode: [
          { validator: validateEmaiCode, trigger: 'blur', equired: true },
        ],
      },
      //账号安全验证
      safeRules: {
        safeAccount: [
          { validator: validateSafe, trigger: 'blur', equired: true },
        ],
        safeCode: [
          { validator: validateSafeCode, trigger: 'blur', equired: true },
        ],
      },
      //账号密码重置验证
      resetRules: {
        newPass: [
          { validator: validateNewPass, trigger: 'blur', equired: true },
        ],
      },
      searchVal: '',
      // accountInfo: {},
      userType: '', //保存用户类型
      loginName: '',
      Password: '',
      loginForm: {
        loginName: '',
        Password: '',
      },
      code: '', //验证码
      timer: null,
      codeTimer: 120, //时间计时器
      codeVal: '', //验证码状态
      accountVal: false, //账后是否注册的状态
      signupForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      signupEmailForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      safeForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      saveNextVal: false,
      resetForm: {
        Password: '',
        Password2: '',
      },
      resetError: false,
      passStatus: null, //设置密码的验证状态
      pagination: {
        PageSize: 8,
        PageIndex: 1,
      },
      Logo: {
        img: require('../../assets/images/hardwareManagement/logo.png'),
      },
      User: {
        profile: null,
        profile2: require('../../../public/images/profile03.png'),
      },
      // 马上创作指令字符串
      createCmdString: '',
      // 首页、我的项目、模型训练、严选课程、热门赛事、技能认证
      Nav: [
        {
          name: 'model_training',
          label: '教学中心',
          redirect: 'unDo',
          path: '',
        },
        {
          name: 'my_project',
          label: '实训中心',
          redirect: 'projects-training-project',
          path: '/projects/trainingproject',
        },
        {
          name: 'model_training',
          label: '模型训练',
          redirect: 'pretrain',
          path: '/pretrain/',
        },
        {
          name: 'model_training',
          label: 'AI-T 编辑器',
          redirect: 'unDo',
          path: '',
        },

        {
          name: 'model_training2',
          label: '行业应用',
          redirect: 'application-index',
          path: '/industral/application',
        },
        {
          name: 'model_training4',
          label: '体验实训',
          redirect: '',
          path: '',
        },
        {
          name: 'dataset-lobby',
          label: '数据集大厅',
          redirect: 'dataset-lobby',
          path: '/pretrain/datasetlobby',
        },
        {
          name: 'hardware-center',
          label: '硬件管理',
          redirect: 'hardware-center',
          path: '/hardwareCenter',
        },
      ],
      Icons: {
        Search: {
          iconName: '搜索',
          viewBox: '0 0 20 20',
          width: '20',
          height: '20',
        },
        PopupClose: {
          iconName: '关闭',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"
        },
      },
      popupActive: '',
      checked: true,
      phoneChecked: true,
      emailChecked: true,
      LoginTeenDays: true,
      isLogin: true,
      isPhone: true,
      isSafe: false,
      isReset: false,
      hasLogin: null,
    }
  },
  computed: {
    userRole() {
    return this.$store.state.userRole
    },
    accountInfo: {
      get(val) {
        return this.$store.state.accountInfo
      },
      set(val) {
        this.User.profile = val.UserImgUrl
      },
    },
  },
  watch: {
    $route: function(to, from) {},
    openLogin(newVal) {
      if (newVal == 'login') {
        this.activeLoginPopup()
      }
    },
    // accountInfo: {
    //   immediate: true,
    //   deep: true,
    //   handler: function accountInfo2(data) {
    //     // this.accountInfo = data;
    //     this.User.profile = data.UserImgUrl;
    //     console.log(333, data)
    //   }
    // }
  },
  created() {
    this.createCmdString = 'create'
    var hasLogin = sessionStorage.getItem('hasLogin')
    if (!hasLogin) {
      this.hasLogin = false
      //未登录时，判断是否自动登录 先注释十天免登录的自动登录功能;
      // if (this.$cookies.get("loginForm")) this.autoLogin();
      // if (utils.tokenExpressInTime) this.autoLogin();
    } else {
      this.hasLogin = Boolean(hasLogin)
      if (hasLogin) {
        this.token = this.$store.state.token
        // this.accountInfo = this.$store.state.accountInfo;
        this.userType = this.$store.state.userType
        if (this.accountInfo) this.User.profile = this.accountInfo.UserImgUrl
      }
    }
  },
  mounted() {
    let that = this

    bus.$on('quit', () => {
      that.popupActive = 'login'
    })
    //处理路由路径
    this.originPathHandle()
  },
  updated() {},
  destroyed() {
    console.log('destroyed')
  },
  methods: {
    //跳转新窗口
    onNewWindow(item, index) {
      let { label } = item
      switch (label) {
        case '体验实训': {
          window.open('../../../modules/experianceAI/index.html')
          break
        }
        default:
          break
      }
    },
    originPathHandle() {
      let { Nav } = this
      let pathname = window.location.pathname

      Nav.forEach((item, index) => {
        let path = new RegExp(item.path)
        if (item.path && path.test(pathname)) {
          this.originPath = index
        }
      })
    },

    // 将马上创作进行分发事件
    activeCreatePopup(evt) {
      if (this.$route.name !== 'projects-training-project') {
        var createCmdString = this.createCmdString

        this.$router.push({
          // name: "my-project",
          name: 'projects-training-project',
          params: { operate: createCmdString },
        })
        return
      }
      this.$emit('active-create', evt)
    },

    //登录弹窗
    activeLoginPopup() {
      this.popupActive = 'login'
      this.isLogin = true
      this.isPhone = false
      this.isSafe = false
      this.isReset = false
      this.loginForm = { loginName: '', Password: '' }
      this.signupForm = { loginName: '', Password: '', code: '' }
      this.signupEmailForm = { loginName: '', Password: '', code: '' }
      this.safeForm = { loginName: '', code: '' }
      this.resetForm = { Password: '' }
      this.codeTimer = 120
      this.codeVal = ''
      this.resetError = false
      this.saveNextVal = false
    },
    // // 取消弹窗
    cancelPopup() {
      this.popupActive = ''
      this.isLogin = false
      this.isPhone = false
      this.isSafe = false
      this.isReset = false
      this.$emit('cancelLogin')
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) { console.log(e)}
    },
    backgroundClickedCancel(evt) {
      // 点击背景关闭弹窗
      var target = evt.target
      if (target.classList.contains('popup')) {
        this.cancelPopup()
      }
    },

    //账号设置跳转
    JumpSetting() {
      this.$router.push({ name: 'account-setting' })
    },
    //个人中心跳转6000
    JumpPersonal() {
      this.$router.push({ name: "projects-list" });
      // if (this.userType == '8000') {
      //   this.$router.push({ name: 'personal-tearcher' })
      // } else if (this.userType == '6000') {
      //   this.$router.push({ name: 'personal-student' })
      // }
    },

    //跳转到注册页
    RegSwitch() {
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) { console.log(e)}
      try {
        this.$refs.signupEmailForm.clearValidate()
      } catch (e) { console.log(e)}
      this.isLogin = false
      this.isReset = false
      this.isSafe = false
      this.isPhone = true
    },
    //忘记密码跳转
    SafeSwich() {
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) { console.log(e)}
      this.isLogin = false
      this.isSafe = true
      this.isReset = false
    },
    //发送验证码
    /**
    @param accountType 注册账号(手机号或邮箱)
    @param type 1 注册时;2 重置时
    **/
    async sendVerifyCode(accountType, type) {
      // if (this.codeVal == 'sending' || this.codeVal == 'loading') return
      // this.accountVal = false //清空该账号状态
      // this.code = '' //清空验证码
      // let account,
      //   phone_match = /^1[358]\d{9}$/, //验证电话
      //   mail_match = /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/
      // //注册验证
      // if (type == '1') {
      //   if (accountType == 'phone') {
      //     account = this.signupForm.loginName
      //     this.signupForm.code = ''
      //   } else if (accountType == 'email') {
      //     account = this.signupEmailForm.loginName
      //     this.signupEmailForm.code = ''
      //   }
      // } else if (type == '2') {
      //   //找回密码验证
      //   let safeForm = this.safeForm
      //   account = safeForm.loginName
      //   if (!phone_match.test(account) && !mail_match.test(account)) {
      //     return
      //   }
      // }
      // if (!account) return
      // //必须等60s后才能进行点击调用验证码请求，防止短时间多次点击。
      // this.codeVal = 'loading'
      // let res = await Login.SendVerificationCode(account, type)
      // if (res && res.isSuccess == true) {
      //   this.codeVal = 'sending'
      //   this.codeVerify(res.Data) //获取验证码并计时
      //   this.$message.success('发送成功')
      // } else if (res.ErrorCode && res.ErrorCode == '50109') {
      //   this.$message.error(res.ErrorMsg)
      //   this.codeVal = 'sended'
      //   this.accountVal = true //表示这个账号已经注册，不允许再注册
      // }
    },
    //获取验证码并计时
    codeVerify(code) {
      this.code = code
      this.timer = setInterval(() => {
        if (this.codeTimer > 0) {
          this.codeTimer--
        } else {
          clearInterval(this.timer)
          this.codeTimer = 120
          this.codeVal = 'sended'
        }
      }, 1000)
    },
    //切换手机注册表单
    RegPhone() {
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) { console.log(e)}
      this.isLogin = false
      this.isPhone = true
      this.isSafe = false
      this.isReset = false
    },
    //确定手机注册
    async confirmPhoneSignup(formName) {
      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //     let signupForm = this.signupForm,
      //       { loginName, Password, code } = signupForm,
      //       data = {}
      //     if (this.accountVal) {
      //       return this.$message.error('该账号已被注册')
      //     }
      //     if (this.codeVal == 'sended') {
      //       return this.$message.error('请再次发送验证码')
      //     }
      //     if (!this.code) {
      //       return this.$message.error('请输入验证码')
      //     }
      //     if (!loginName || !Password || !code) {
      //       return
      //     }
      //     data = {
      //       loginName: loginName,
      //       Password: Password,
      //     }
      //     let regResult = await Login.Register(data)
      //     if (regResult && regResult.isSuccess) {
      //       this.$message.success('注册成功')
      //       this.codeVal = 'sended'
      //     } else if (regResult.ErrorMsg) {
      //       this.$message.error(regResult.ErrorMsg)
      //     }
      //   }
      // })
    },
    //切换邮箱注册表单
    RegMail() {
      try {
        this.$refs.signupForm.clearValidate()
      } catch (e) { console.log(e)}
      this.isPhone = false
      this.isSafe = false
      this.isReset = false
    },
    //确定用邮箱注册
    async confirmEmileSignup(formName) {
      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //     let signupEmailForm = this.signupEmailForm,
      //       { loginName, Password, code } = signupEmailForm,
      //       data = {}
      //     if (this.accountVal) {
      //       return this.$message.error('该账号已被注册')
      //     }
      //     if (this.codeVal == 'sended') {
      //       return this.$message.error('请再次发送验证码')
      //     }
      //     if (!this.code) {
      //       return this.$message.error('请输入验证码')
      //     }
      //     if (!loginName || !Password || !code) {
      //       return
      //     }
      //     data = {
      //       loginName: loginName,
      //       Password: Password,
      //     }
      //     let regResult = await Login.Register(data)
      //     if (regResult && regResult.isSuccess) {
      //       this.$message.success('注册成功')
      //       this.codeVal = 'sended'
      //     } else if (regResult.ErrorMsg) {
      //       this.$message.error(regResult.ErrorMsg)
      //     }
      //   }
      // })
    },

    SafeNext(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.$refs.safeForm.clearValidate()
          } catch (e) { console.log(e)}
          this.isLogin = false
          this.isSafe = false
          this.isReset = true
          this.codeVal = 120
          clearInterval(this.timer)
        }
      })
    },
    //验证密码强度
    varifyPassSet(val) {
      let pass = this.resetForm.Password.trim(),
        len = pass.length,
        reg_pass_1 = /^[\da-zA-Z._~!@#$^&*]{8,16}$/, //含有字母、数字、字符中的1种
        reg_pass_2 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![!#$%^&*]+$)[\da-zA-Z._~!@#$^&*]{8,16}$/, //含有字母、数字、特殊字符中的2种以上的
        reg_pass_3 = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[._~!@#$^&*])[0-9a-zA-Z._~!@#$^&*]{8,16}$/ //含有字母、数字、特殊字符中的3种
      // debugger;
      if (!reg_pass_1.test(pass)) {
        this.passStatus = null
      } else if (reg_pass_1.test(pass) && !reg_pass_2.test(pass)) {
        this.passStatus = 'weak'
      } else if (reg_pass_2.test(pass) && !reg_pass_3.test(pass)) {
        this.passStatus = 'medium'
      } else if (reg_pass_3.test(pass)) {
        this.passStatus = 'strong'
      }
      // if()
    },

    //重置
    Reset(formName) {
      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //     let resetForm = this.resetForm,
      //       loginName = this.safeForm.loginName,
      //       { Password, code } = resetForm,
      //       data = { loginName, Password }
      //     let res = await Login.ResetPassword(data)
      //     if (res && res.isSuccess) {
      //       this.$message.success(res.Data)
      //       this.isReset = false
      //       this.popupActive = ''
      //       try {
      //         this.$refs[formName].resetFields()
      //         this.$refs[formName].clearValidate()
      //       } catch (e) {}
      //     } else if (res.ErrorMsg) {
      //       this.$message.error(res.ErrorMsg)
      //     }
      //   }
      // })
    },

    Login(formName) {
      var self = this,
        loginForm = this.loginForm
      loginForm.loginName = loginForm.loginName.trim()
      let data = {
        loginName: loginForm.loginName,
        pwd: loginForm.Password,
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          LOGIN.login(data).then((res) => {
            if (res && res.isSuccess) {
              let Data = res.data
              self.hasLogin = true
              sessionStorage.setItem('hasLogin', true)
              sessionStorage.setItem('accountInfo', JSON.stringify(Data.data))
              sessionStorage.setItem('token', JSON.stringify(Data.token))
              this.$store.commit('accountInfo', Data.data)
              // debugger;
              self.$store.commit('token', Data.token)
              self.$store.commit('userType', Data.data.type) // 用户类型
              self.token = Data.token
              self.userType = Data.data.type
              self.accountInfo = Data.data
              self.$store.commit('userStatus', true)
              self.popupActive = ''
              self.$refs.loginForm.clearValidate()
              self.User.profile = JSON.parse(
                sessionStorage.getItem('accountInfo')
              ).UserImgUrl
              if (self.LoginTeenDays) {
                if (!localStorage.tokenTime) {
                  let date = new Date().getTime() + 6 * 3600 * 1000
                  localStorage.setItem('tokenTime', date)
                  // localStorage.loginForm = JSON.stringify(loginForm) 
                } else {
                  localStorage.clear()
                }
                self.$emit('confirmLogin')
              }
            } else {
              //报错的提示
              this.$message.error(res.returnMsg)
            }
          })
        }
      })
    },

    //自动登录
    autoLogin() {
      // var self = this,
      //   loginForm = localStorage.loginForm,
      //   data = {
      //     ...loginForm,
      //   }
      // Login.LoginPost(data).then((res) => {
      //   var success = res.isSuccess
      //   if (success) {
      //     let Data = res.Data
      //     self.hasLogin = true
      //     sessionStorage.setItem('hasLogin', true)
      //     sessionStorage.setItem('accountInfo', JSON.stringify(Data))
      //     self.accountInfo = Data
      //     this.$store.commit('accountInfo', Data)
      //     self.$store.commit('token', Data.token)
      //     self.$store.commit('userType', Data.UserType)
      //     self.token = Data.token
      //     self.hasLogin = true
      //     self.userType = Data.UserType
      //     self.$store.commit('userStatus', true)
      //     self.popupActive = ''
      //     self.User.profile = JSON.parse(
      //       sessionStorage.getItem('accountInfo')
      //     ).UserImgUrl

      //     self.$forceUpdate()
      //     if (self.LoginTeenDays) {
      //       if (!localStorage.tokenTime) {
      //         let date = new Date().getTime() + 6 * 3600 * 1000
      //         localStorage.setItem('tokenTime', date)
      //         localStorage.loginForm = loginForm
      //       } else {
      //         localStorage.clear()
      //       }
      //       self.$emit('confirmLogin')
      //     }
      //   }
      // })
    },

    //退出登录
    quitLogin() {
      var self = this
      self.hasLogin = false
      self.accountInfo.realName = ''
      self.accountInfo.roleNames = ''
      sessionStorage.setItem('hasLogin', '') //null,false,'',
      sessionStorage.token = ''
      self.$store.commit('userStatus', 'false')
      self.$router.push('/')
      // this.$cookies.remove('loginForm') //注销登录cookie
      localStorage.clear() //清除localStorage
      setTimeout(() => {
        bus.$emit('quit')
      }, 500)
    },
    toLogin() {
      if (!this.hasLogin) {
        this.activeLoginPopup()
      }
    },
    focusInput(event) {
      // event.currentTarget.setAttribute("width", "220px");
      // event.currentTarget.style.width = "250px";
      if (!this.hasLogin) {
        this.popupActive = 'login'
        let readonly = event.currentTarget.getAttribute('readonly')
        if (!readonly) event.currentTarget.setAttribute('readonly')
        return
      }

      event.currentTarget.removeAttribute('readonly')
    },
    getInput(event) {
      this.$emit('onSearchVal', this.searchVal)
    },
  },
}
</script>

<style lang="scss" scoped>
$head_height: 80px;
.gat-head {
  position: relative;

  height: $head_height;
  // padding: 0 30px;
  // background: #151634;
}
.head-left {
  float: left;
  width: 150px;
  height: 80px;
  white-space: nowrap;
  .head-title {
    float: left;
    display: block;
    box-sizing: border-box;
    width: 150px;
    height: 100%;
    font-size: $font_size_logo_title;
    font-weight: normal;
    line-height: $head_height;
    .i-spot {
      width: 4px;
      height: 4px;
      background: #ffffff;
      display: inline-block;
      border-radius: 50%;
      margin: 0 12px 5px 170px;
    }
    .title-name {
      font-size: 22px;
      font-family: ShiShangZhongHeiJianTi;
      font-weight: 400;
      color: #ffffff;
      margin-left: 0px;
    }
  }
  .head-title-img {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    cursor: pointer;
    & ~ span {
      margin-left: 52px;
      color: #fff;
      font-size: 22px;
    }
  }
  .head-left-item {
    padding-left: 10px;
    font-size: $font_size_nav;
    color: $font_color_1st;
    .el-dropdown {
      margin-left: 10px;
      font-size: $font_size_nav;
      color: $font_color_1st;
      .el-dropdown-link {
        padding: 0.75em 0;
      }
    }
    &.el-button {
      padding-left: 0;
      border: none;
      background: transparent;
      .icon_nav-icon {
        margin-right: 6px;
      }
      &.el-popper {
        margin-top: 4px;
        margin-left: 140px;
      }
    }
    .icon_nav-icon {
      width: auto;
      height: 1em;
    }
  }
  .head-file {
    display: inline-block;
    width: 100px;
    height: 34px;
    line-height: 34px;
    margin-left: 20px;
    margin-right: 12px;
    border: 1px solid transparent;
    box-sizing: border-box;
    font-size: 14px;
    transition: border linear 0.3s;
  }
  .head-file:hover {
    border: 1px solid #5777bb;
    background-image: linear-gradient(to right, #678cff, transparent);
  }
}
.head-center {
  position: absolute;
  left: 25.2%;

  .items {
    overflow: hidden;
    .nav-item {
      float: left;
      padding: 0 20px;
      margin: 0 6px;
      height: 80px;
      line-height: $head_height;
      border-top: 3px solid transparent;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      box-sizing: border-box;
      &:hover,
      &.active {
        color: #fff;
        background: #202d5d;
        border-top: 3px solid;
        border-image: linear-gradient(to right, #7f70ff, #3c7dff) 1;
      }
    }
  }
}
.head-right {
  float: right;
  height: 80px;
  // line-height: 80px;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: $font_size;
  // transition: all 0.6s;
  .search {
    position: relative;
    float: left;
    margin-right: 52px;
    &-input {
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      padding: 0 35px 0 10px;
      width: 180px;
      box-sizing: border-box;
      border: none;
      background: #202d5d;
      color: #fff;
      transition: all 0.6s;
      &::-webkit-input-placeholder {
        color: #6e7fbe;
      }
    }

    .icon-search-box {
      position: absolute;
      right: 0px;
      top: -8px;
      cursor: pointer;
    }

    .ipt {
      position: relative;
      float: right;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      font-size: 16px;
      color: #7a7c84;
      box-sizing: border-box;
      z-index: 2;
      overflow: hidden;
      &::-ms-clear {
        display: none;
      }
      ::v-deep.el-input__inner {
        height: 30px;
        color: #fff;
        // outline: none;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-radius: 15px;
        &::-webkit-input-placeholder {
          color: #fff;
        }
        &::-moz-input-placeholder {
          color: #fff;
        }
        &::-ms-input-placeholder {
          color: #fff;
        }
      }
      ::v-deep.el-input.is-active .el-input__inner,
      ::v-deep.el-input__inner:focus {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-radius: 15px;
      }

      .icon-search-box {
        color: #fff;
        font-size: 20px;
        vertical-align: -13px;
        padding-right: 5px;
        cursor: pointer;
        line-height: 48px;
      }
    }
  }

  .ml20 {
    width: 110px;
    margin-left: 20px;
  }
  // search
  .sep {
    display: inline-block;
    height: 50%;
    width: 1px;
    margin: 0px 20px 0;
    background-color: #46538b;
  }
  .userinfo {
    float: right;
    // display: inline-block;
    white-space: nowrap;
    display: flex;
    justify-content: start;
    align-items: center;
    .profile {
      position: relative;
      display: flex;
      // width: 44px;
      // height: 44px;
      // line-height: 44px;
      // text-align: center;
      // vertical-align: middle;
      cursor: pointer;
      color: #fff;
      justify-content: start;
      align-items: center;
      > img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
      &:hover .profile-menu {
        display: block;
      }
      &-menu {
        display: none;
        position: absolute;
        width: 120px;
        height: 130px;
        left: 50%;
        margin-left: -60px;
        top: 38px;
        box-shadow: 0 0 1px 1px #e8ecf9;
        border-radius: 3px;
        z-index: 3;
        background: #fff;
        padding: 5px 0;
        border: none;
        box-sizing: border-box;
        &:before {
          position: absolute;
          top: -20px;
          left: 50%;
          margin-left: -10px;
          display: inline-block;
          width: 0;
          height: 0;
          border: 10px solid;
          border-color: transparent transparent #fff;
          content: '';
        }

        li {
          float: left;
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #151634;
          background: #fff;
          cursor: pointer;
          &:hover {
            color: #fff;
            background: linear-gradient(to right, #7f70ff, #3c7dff);
          }
        }
      }
    }
    .user-info-wrap {
      width: auto;
      height: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      font-size: 14px;
      margin-left: 10px;
      color: #fff;
      .role-name {
        display: inline-block;
        // background: linear-gradient(to left, #367aff, #b15fff);
        background: #955AFF;
        font-size: 12px;
        margin-left: 10px;
        border-radius: 10px 10px 10px 0;
        padding: 0px 8px;
        // box-sizing: border-box;
        line-height: 2;
      }
    }
    .el-dropdown {
      display: inline-block;
      margin-left: 10px;
      color: $font_color_1st;
      vertical-align: middle;
    }
    .el-button--primary {
      border: none;
      font-size: 16px;
      background: linear-gradient(to right, #7f70ff, #3c7dff);
    }
  }
}
.popup-list {
  flex-grow: 0;
  width: auto;
  .popup-login,
  .popup-delete {
    &.off {
      display: none;
    }
  }

  .popup-upload {
    .loading {
      pointer-events: none;
      opacity: 0.75;
    }
  }

  .popup-delete {
    &::v-deep .popup-head {
      border-bottom: 0 none;
    }
    .popup-del-cnt {
      overflow: hidden;
      margin-top: -25px;
      .head {
        .icon-box {
          display: inline-block;
          margin-right: 12px;
          vertical-align: middle;
        }
        .title {
          display: inline-block;
          color: #333;
          vertical-align: middle;
        }
      }
      .content {
        padding: 15px 0;
        text-align: center;
      }
    }
  }
}

.popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $background_popup;
  z-index: 999;
  .popup-inner {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 462px !important;
    height: 560px !important;
    border-top: 1px solid #e9eaec;
    margin: auto;
    padding-bottom: 30px;
    background-color: $background_popup_inner;
    box-shadow: 0px 4px 14px 0px rgba(5, 27, 69, 0.12);
    color: #6c7682;
    font-size: $font_size_middle;
    box-sizing: border-box;
  }
}

.popup-inner {
  border: 1px solid #e9eaec;
  width: 460px;
  height: 560px;
  box-sizing: border-box;
  .popup-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 55px;
    padding: 0 15px 0 30px;
    // border-bottom: 1px solid #d8e5fd;
    line-height: 55px;
    .title {
      vertical-align: middle;
    }
    .icon-close {
      width: 30px;
      height: 30px;
      margin-left: auto;
      vertical-align: middle;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      &:hover::v-deep .path-icon-close {
        fill: #4c88ff;
      }
    }
  }
  .popup-content {
    padding: 0 30px;
    ::v-deep .el-input {
      border: 0px soild #fff;
      // height: 40px;
      // margin-top: 30px;
      &::v-deep input::placeholder {
        color: #8f939e;
      }
    }
  }
  .popup-buttons {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    .el-button {
      width: 90px;
      height: 40px;
      margin-left: 25px;
      font-size: $font_size_middle;
      &:first-child {
        margin-left: 0;
      }
      &.primary {
        background-color: $bgc_btn_primary;
        color: $font_color_1st;
      }
      &.cancel {
        background-color: $bgc_btn_cancel;
        color: $color_btn_cancel;
        &:active {
          border-color: $bgc_btn_cancel;
        }
      }
    }
  }
}
.popup-login {
  .tab {
    margin-top: -25px;
    display: flex;
    justify-content: center;

    .item {
      width: 120px;
      line-height: 58px;
      border-bottom: 2px solid transparent;
      text-align: center;
      color: #333;
      font-size: 20px;
      margin-top: 0;
      padding-right: 0;
      margin: 0 12px;
      cursor: pointer;
      &.active {
        color: #2b6ceb;
        border-bottom: 2px solid #4c88ff;
      }
    }
  }

  .login {
    padding: 0 20px;
    margin-top: 60px;
    .input-item {
      margin-bottom: 40px;
    }

    .input-login {
      float: left;
      margin-right: 10px;
      width: 100%;
      // width: 260px;
      height: 50px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      background: #4c88ff;
      border: none;
      outline: 0 none;
      box-sizing: border-box;
      margin-bottom: 25px;
      margin-top: 32px;
      cursor: pointer;
    }
    .input-login-reg {
      float: right;
      width: 90px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      color: #777d8b;
      background: #d7dfef;
      border: none;
      outline: 0 none;
      box-sizing: border-box;
      // margin-bottom: 25px;
      margin-top: 32px;
      cursor: pointer;
    }

    .forget {
      float: right;
      font-size: 16px;
      color: #2b6ceb;
      line-height: 28px;
      cursor: pointer;
    }
  }
  .phone {
    padding: 0 20px;
    margin-top: 40px;
    .input-item {
      margin-bottom: 30px;
      ::v-deep .el-form-item__error {
        padding-top: 10px;
      }
    }
    .number-phone {
      margin: 0 auto;
      padding-left: 0px !important;
      border: 0px solid #fff;
    }
    .ico02 {
      position: absolute;
      margin: 16px 15px !important;
      z-index: 999;
      border-right: 1px solid #aaa;
      padding-right: 10px;
    }

    ::v-deep .el-form-item {
      .el-form-item__content {
        margin-top: 0px !important;
      }
    }
  }
  .mail {
    padding: 0 20px;
    margin-top: 40px;
    .input-item {
      margin-bottom: 30px;
    }
  }

  .safe {
    padding: 0 20px;
    margin-top: 40px;
    .input-item {
      margin-bottom: 40px;
    }
  }
  //重置密码状态
  .reset-form {
    .mt50 {
      margin-top: 120px;
    }
    .pass-show-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-content: center;
      margin-top: 30px;
      padding: 10px 0px;
      background: #efefef;
      span {
        margin-left: 10px;
        width: 80px;
        height: 20px;
        background: #fff;
        transition: background 0.5s;
        &.weak,
        &.medium,
        &.strong {
          background: #5bba48;
        }
      }
      p {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
      }
    }
    .tip-wrap {
      color: red;
      text-align: left;
      font-size: 12px;
      margin-top: 30px;
      padding: 10px;
      border: 1px solid red;
      width: 100%;
      box-sizing: border-box;
      // height: 70px;
    }
    .confirm-reset {
      width: 360px;
      position: absolute;
      margin-bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  //公用
  &::v-deep .el-input {
    width: 100%;
    height: 50px;
    line-height: 50px;
    //border: 1px solid #d2d9e0;
    font-size: 16px;
    box-sizing: border-box;
    color: #333;
    background: #fff;
    border: 0px;
    .input {
      margin-left: 0px;
      width: 100%;
    }
    &.error {
      border: 1px solid #ff3f51;
    }
    .el-input__inner {
      height: 50px;
      border-radius: 0px;
      padding-left: 62px;
    }
  }
  ::v-deep .el-form-item__error {
    padding-top: 10px;
  }
  //公用
  .input {
    width: 100%;
    height: 50px;
    line-height: 50px;
    // padding-left: 62px;
    // border: 1px solid #d2d9e0;
    font-size: 16px;
    box-sizing: border-box;
    color: #333;
    background: #fff;
    &.error {
      border: 1px solid #ff3f51;
    }
  }
  .input-item {
    height: 50px;
    position: relative;
    width: 100%;
    > i {
      position: absolute;
      left: 16px;
      top: 13px;
      display: inline-block;
      width: 33px;
      height: 23px;
      border-right: 1px solid #e2e4f5;
    }
    > em {
      position: absolute;
      right: 9px;
      top: 13px;
      display: inline-block;
      width: 24px;
      height: 24px;
    }
    .reminder {
      font-size: 16px;
      color: #2b6ceb;
    }

    &.mb0 {
      margin-bottom: 0;
    }
  }
  .info {
    color: #666;
    margin-left: 10px;
    em {
      color: #2b6ceb;
      font-style: normal;
      cursor: pointer;
    }
  }
  .note {
    float: left;
    width: 100%;
    line-height: 28px;
    text-align: left;
  }
  .input-code {
    float: left;
    margin-right: 10px;
    width: 230px;
    height: 50px;
    line-height: 50px;
    color: #333;
    &.w100 {
      width: 100%;
    }
  }
  .send-code {
    float: right;
    width: 120px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #4c88ff;
    outline: none;
    background: #f2f6ff;
    text-align: center;
    font-size: 16px;
    color: #2b6ceb;
    cursor: pointer;
    box-sizing: border-box;
  }
  .input-reg {
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top: 45px;
    font-size: 18px;
    text-align: center;
    border: none;
    outline: none;
    background: #4c88ff;
    color: #fff;
    cursor: pointer;
    &.mt50 {
      margin-top: 50px;
    }
  }

  .tip {
    position: absolute;
    top: 54px;
    left: 1px;
    font-size: 14px;
    color: #ff3f51;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      position: relative;
      top: 3px;
      margin-right: 5px;
    }
  }

  .mb60 {
    margin-bottom: 60px;
  }

  .ico01 {
    background: url('../../../public/images/ico39.png') 0 2px no-repeat;
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    margin: 15px 15px;
    z-index: 999;
    border-right: 1px solid #aaa;
    padding-right: 10px;
  }
  .ico02 {
    background: url('../../../public/images/ico40.png') no-repeat;
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    margin: 15px 15px;
    z-index: 999;
    border-right: 1px solid #aaa;
    padding-right: 10px;
  }
  .ico03 {
    background: url('../../../public/images/ico41.png') no-repeat;
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    margin: 17px 15px;
    z-index: 999;
    border-right: 1px solid #aaa;
    padding-right: 10px;
  }
  .ico04 {
    background: url('../../../public/images/ico42.png') 0 4px no-repeat;
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    margin: 15px 15px;
    z-index: 999;
    border-right: 1px solid #aaa;
    padding-right: 10px;
  }
  .ico05 {
    background: url('../../../public/images/ico43.png') no-repeat;
  }
  .ico06 {
    background: url('../../../public/images/ico44.png') no-repeat;
  }
  .ico07 {
    background: url('../../../public/images/ico45.png') no-repeat;
  }
}
@media screen and (max-width: 1480px) {
  .head-center {
    left: 20.2%;
  }
  .head-center .items .nav-item {
    padding: 0 16px;
  }
  @media screen and (max-width: 1280px) {
    .head-center {
      left: 16.2%;
    }
    .head-center .items .nav-item {
      padding: 0 12px;
    }
  }
}
.active-head-file {
  border: 1px solid #5777bb;
  background-image: linear-gradient(to right, #678cff, transparent);
}
.dispermit {
  pointer-events: none;
  opacity: 0.6;
  a {
    color: #999 !important;
  }
}
</style>
